import { useState, useEffect, useRef } from "react";
import { ESTILO_BOTON_MODAL_ACEPTAR } from "../../utils/const/estilos-const";
import "../../style/style-cargando.css";
import cargandoCard from "../../components/cargando-card";
import sinAccesoCard from "../../components/sin-acceso-card";

// import { SELECT_HABILITADO_DESHABILITADO } from "../../utils/const/const-select-habilitado-deshabilitado";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";
import Calendar from "../../components/calendar";
import moment from "moment";
import { obtenerTodasLasUnidades } from "../../api/gestion-dts/gestion";
import { obtenerTodaInformacionDetallePedido } from "../../api/api-detalle-pedido";
import { TableEntregasTable } from "../../components/table_entregas_component";
import shortid from "shortid";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB } from "../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../usuarios/gestionar-rol-usuario-web/pages-const";

/* @param {unknown} val 
function escapeCsvField(val) {
  const s = val == null ? "" : String(val);
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}
  */

/*
 * Flatten programa rows for CSV.
 * One CSV line per pedido-product (or pedido-only if no products).
 
function buildEstadoEntregasCsvStrings(datosInforme, fechaEntregaLabel) {
  const header = [
    "fecha_informe",
    "vehiculo",
    "numero_documento",
    "id_cliente",
    "codigo_cliente",
    "nombre_cliente",
    "latitud",
    "longitud",
    "nombre_geocerca",
    "id_empresa",
    "fecha_proceso_workflow",
    "id_producto",
    "nombre_producto",
    "unidad_medida",
    "cantidad",
    "peso",
    "volumen",
    "monto",
    "moneda",
  ].join(",");

  const lines = [header];

  const pushRow = (
    fecha,
    placa,
    ped,
    prod
  ) => {
    const wf = Array.isArray(ped.workFlow) && ped.workFlow.length > 0
      ? ped.workFlow[ped.workFlow.length - 1]
      : null;
    const fechaWF = wf?.fechaProceso
      ? moment(wf.fechaProceso).format("YYYY-MM-DD HH:mm:ss")
      : "";

    lines.push([
      escapeCsvField(fecha),
      escapeCsvField(placa),
      escapeCsvField(ped.numeroDocumento),
      escapeCsvField(ped.idCliente),
      escapeCsvField(ped.codigoCliente),
      escapeCsvField(ped.nombreCliente),
      escapeCsvField(ped.latitud),
      escapeCsvField(ped.longitud),
      escapeCsvField(ped.nombreGeocerca),
      escapeCsvField(ped.idEmpresa),
      escapeCsvField(fechaWF),
      escapeCsvField(prod?.idProducto ?? ""),
      escapeCsvField(prod?.nombreProducto ?? ""),
      escapeCsvField(prod?.unidadMedida ?? ""),
      escapeCsvField(prod?.cantidad ?? ""),
      escapeCsvField(prod?.peso ?? ""),
      escapeCsvField(prod?.volumen ?? ""),
      escapeCsvField(prod?.monto ?? ""),
      escapeCsvField(prod?.moneda ?? ""),
    ].join(","));
  };

  for (const grupo of datosInforme || []) {
    const placa = grupo.labelPlaca ?? "";
    const lista = Array.isArray(grupo.detallePedidoProgramado)
      ? grupo.detallePedidoProgramado
      : [];
    for (const ped of lista) {
      const prods = Array.isArray(ped.productos) ? ped.productos : [];
      if (prods.length === 0) {
        pushRow(fechaEntregaLabel, placa, ped, null);
      } else {
        for (const prod of prods) {
          pushRow(fechaEntregaLabel, placa, ped, prod);
        }
      }
    }
  }

  const bom = "\uFEFF";
  return bom + lines.join("\r\n");
}
  */

export default function ReporteResumenEntregasPage() {
  const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
  // const history = useHistory();
  const { t } = useTranslation();
  // const [rowsData, setRowsData] = useState([]);
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  // const [showModalFormGenerico, setShowModalFormGenerico] = useState(false);
  // const [formData, setFormData] = useState({});
  // const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

  const [fechaInicioSelected, setFechaInicioSelected] = useState(
    moment().startOf("week").format("YYYY-MM-DD")
  );
  const [fechaFinSelected, setFechaFinSelected] = useState(
    moment().endOf("week").format("YYYY-MM-DD")
  );

  const [listaVehiculos, setListaVehiculos] = useState([]);
  const [vehiculoSelected, setVehiculoSelected] = useState(null);

  const [detalleInforme, setDetalleInforme] = useState([]);

  const [mensajeProcesando, setMensajeProcesando] = useState(t("alert_procesando_solicitud"));

  const [exportPdfRunning, setExportPdfRunning] = useState(false);
  const [exportPdfPercent, setExportPdfPercent] = useState(0);

  const contentRef = useRef(null);

  const [btnBuscar, setBtnBuscar] = useState(false);
  const [btnExportar, setBtnExportar] = useState(false);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    let tieneAcceso = false;
    try {
      let objEnviar = {};
      if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
        tieneAcceso = true;
        setBtnBuscar(true);
        setBtnExportar(true);
      }
      if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
        const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
        objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
        const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
        if (response.error === false && response.data !== undefined) {
          const permisos = JSON.parse(response.data.permisos);
          // console.log('permisos');
          // console.log(permisos);
          if (Array.isArray(permisos) && permisos.length > 0) {
            const manage = permisos.find(p => p.id === 10);
            if (manage !== undefined && manage !== null) {
              const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.REPORTE_RESUMEN_ENTREGAS);
              // console.log('permisosPage');
              // console.log(permisosPage);
              tieneAcceso = permisosPage.checked;
              if (tieneAcceso === false) {
                return;
              }
              const permisoBtnBuscar = permisosPage.acciones.find(a => a.value === 'btn_buscar');
              const permisoBtnExportar = permisosPage.acciones.find(a => a.value === 'btn_exportar');
              setBtnBuscar(permisoBtnBuscar?.checked);
              setBtnExportar(permisoBtnExportar?.checked);
            }
          }
        }
      }
      if (tieneAcceso === true) {

        const listaUnidades = await obtenerTodasLasUnidades();
        // console.log('listaUnidades');
        // console.log(listaUnidades);
        setListaVehiculos(listaUnidades);

      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
      setTieneAccesoAlModulo(tieneAcceso);
    }
  };

  const obtenerDatosInforme = async () => {
    try {
      if (moment(fechaInicioSelected).isValid() === false) {
        showToast(t("alert_fecha_invalida"), "error");
        return;
      }
      if (moment(fechaFinSelected).isValid() === false) {
        showToast(t("alert_fecha_invalida"), "error");
        return;
      }
      if (moment(fechaInicioSelected).isAfter(moment(fechaFinSelected))) {
        showToast(t("alert_fecha_inicio_debe_ser_menor_a_fecha_fin"), "error");
        return;
      }
      // here I need to have a list of each day between fechaInicioSelected and fechaFinSelected
      const listaFechas = [];
      const fechaInicio = moment(fechaInicioSelected).startOf("day");
      const fechaFin = moment(fechaFinSelected).startOf("day");
      while (fechaInicio.isSameOrBefore(fechaFin)) {
        listaFechas.push(fechaInicio.format("YYYY-MM-DD"));
        fechaInicio.add(1, "day");
      }
      // console.log('listaFechas');
      // console.log(listaFechas);
      if (listaFechas.length > 31) {
        showToast(t("alert_maximo_31_dias_por_consulta"), "error");
        return;
      }
      for (let i = 0; i < listaFechas.length; i++) {
        const fecha = listaFechas[i];
        // console.log('fecha');
        // console.log(fecha);
        let objEnviar = {};
        objEnviar.fechaEntrega = fecha;
        objEnviar.listaPlacas = vehiculoSelected;
        setProcessingVisible(true);
        setMensajeProcesando(t("alert_procesando_solicitud_detalle_pedido") + " " + fecha);
        const detallePedido = await obtenerTodaInformacionDetallePedido(objEnviar, t);
        console.log('detallePedido');
        console.log(detallePedido);
        if (detallePedido.error === false) {
          setDetalleInforme((prev) => [...prev, ...detallePedido.data]);
        }
        setProcessingVisible(false);
      }

    } catch (err) {
      console.log('obtenerDatosInforme err');
      console.log(err);
      showToast(t("alert_error_al_obtener_datos_informe"), "error");
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  /*
  const handleExportarPdf = async () => {
    try {
      await sharedExportarPdf(contentRef, "reporte-estado-entregas", {
        onStart: () => {
          setExportPdfRunning(true);
          setExportPdfPercent(0);
        },
        onProgress: ({ percent }) => {
          setExportPdfPercent(Number(percent) || 0);
        },
        onFinish: () => {
          setExportPdfRunning(false);
          setExportPdfPercent(0);
        },
        onError: () => {
          showToast(t("label_sin_datos"), "error");
        },
      });
    } catch (err) {
      setExportPdfRunning(false);
      setExportPdfPercent(0);
      showToast(t("label_sin_datos"), "error");
    }
  };

  const handleExportarCsv = () => {
    try {
      if (!Array.isArray(datosInforme) || datosInforme.length === 0) {
        showToast(t("label_sin_datos"), "warning");
        return;
      }
      const csv = buildEstadoEntregasCsvStrings(datosInforme, fechaSelected);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `reporte-estado-entregas-${fechaSelected}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.log(e);
      showToast(t("alert_error_al_obtener_datos_informe"), "error");
    }
  };

  const fetchApiKmForSection = async (item, sectionKey, range) => {
    try {
      setApiKmLoadingBySection((prev) => ({ ...prev, [sectionKey]: true }));
      const objRecorrido = {
        fechaHoraInicio: `${moment(range.dateIni).format("YYYY-MM-DD")} ${range.horaIni}:00`,
        fechaHoraFin: `${moment(range.dateFin).format("YYYY-MM-DD")} ${range.horaFin}:59`,
        placa: String(item.valuePlaca || "").trim(),
        idEmpresa: sharedObtenerIdEmpresa(),
      };
      const responseInfoKilometraje = await obtenerReporteInfoKilometraje(objRecorrido);
      const apiKm = Number(responseInfoKilometraje?.data?.[item.valuePlaca]?.kilometrajeTotal);
      setApiKmBySection((prev) => ({
        ...prev,
        [sectionKey]: Number.isFinite(apiKm) ? apiKm : null,
      }));
    } catch (err) {
      setApiKmBySection((prev) => ({ ...prev, [sectionKey]: null }));
    } finally {
      setApiKmLoadingBySection((prev) => ({ ...prev, [sectionKey]: false }));
    }
  };

  const waitForGoogleMaps = async (timeoutMs = 8000) => {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      if (window?.google?.maps) return true;
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) => setTimeout(resolve, 250));
    }
    return false;
  };

  const calcularKmRutaPlanificada = async (programa) => {
    try {
      if (!window?.google?.maps) return null;
      const maps = window.google.maps;
      const points = (programa || [])
        .map((p) => ({
          lat: parseFloat(p?.latitud),
          lng: parseFloat(p?.longitud),
        }))
        .filter(
          (p) =>
            !Number.isNaN(p.lat) &&
            !Number.isNaN(p.lng) &&
            Number.isFinite(p.lat) &&
            Number.isFinite(p.lng)
        );

      if (points.length < 2) return 0;

      const directionsService = new maps.DirectionsService();
      const MAX_STOPS_PER_SEGMENT = 25;
      let totalMeters = 0;

      const requestRoute = (origin, destination, waypoints) =>
        new Promise((resolve, reject) => {
          directionsService.route(
            {
              origin,
              destination,
              waypoints,
              travelMode: maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status !== maps.DirectionsStatus.OK) {
                reject(new Error(String(status)));
                return;
              }
              resolve(result);
            }
          );
        });

      for (let start = 0; start < points.length - 1; start += (MAX_STOPS_PER_SEGMENT - 1)) {
        const endExclusive = Math.min(start + MAX_STOPS_PER_SEGMENT, points.length);
        const segmentPoints = points.slice(start, endExclusive);
        if (segmentPoints.length < 2) continue;

        const origin = new maps.LatLng(segmentPoints[0].lat, segmentPoints[0].lng);
        const destination = new maps.LatLng(
          segmentPoints[segmentPoints.length - 1].lat,
          segmentPoints[segmentPoints.length - 1].lng
        );
        const waypoints = segmentPoints
          .slice(1, -1)
          .map((p) => ({ location: new maps.LatLng(p.lat, p.lng), stopover: true }));

        // eslint-disable-next-line no-await-in-loop
        const result = await requestRoute(origin, destination, waypoints);
        const route = result?.routes?.[0];
        if (!route) continue;
        (route.legs || []).forEach((leg) => {
          if (leg?.distance?.value) totalMeters += Number(leg.distance.value);
        });
      }

      return totalMeters / 1000;
    } catch (err) {
      return null;
    }
  };*/

  const renderTablaDetalleInforme = () => {
    try {
      if (!Array.isArray(detalleInforme) || detalleInforme.length === 0) {
        return (
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
              <div className="text-sm text-gray-600 mt-4">{t("label_sin_datos")}</div>
            </div>
          </div>
        );
      }
      return (
        <div className="grid grid-cols-12 gap-4 mb-4"
          key={shortid.generate()}
        >
          <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
            <TableEntregasTable
              items={detalleInforme}
              exportMeta={{
                reportName: t("label_reporte_resumen_entregas"),
                dateRangeLabel: `${moment(fechaInicioSelected).format("DD/MM/YYYY")} a ${moment(fechaFinSelected).format("DD/MM/YYYY")}`,
                fileName: `resumen-entregas-${fechaInicioSelected}_${fechaFinSelected}`,
              }}
              btnExportar={btnExportar}
            />
          </div>
        </div>
      );
    } catch (err) {
      console.log('renderTablaDetalleInforme err');
      console.log(err);
      return (
        <div className="text-sm text-gray-600 mt-4">{t("label_sin_datos")}</div>
      );
    }
  };

  const render = () => {
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                {/* <ArrowBack onClick={handleAtrasClick} /> */}
                <h2 className="text-xl font-bold text-gray-900">{t("label_reporte_resumen_entregas")}</h2>
              </div>
              <p className="text-sm text-gray-500">{t("label_genera_el_reporte_de_resumen_de_entregas")}</p>
            </div>
            <div className="flex items-center gap-2">
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4 print:hidden">
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              <label className="block text-sm font-medium text-gray-700 mb-0">{t("label_fecha_programada_inicio")}</label>
              <Calendar
                value={fechaInicioSelected}
                onChange={(date) => setFechaInicioSelected(date)}
                placeholder={t("placeholder_seleccione_fecha")}
                id="fecha_inicio"
                name="fecha_inicio"
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              <label className="block text-sm font-medium text-gray-700 mb-0">{t("label_fecha_programada_fin")}</label>
              <Calendar
                value={fechaFinSelected}
                onChange={(date) => setFechaFinSelected(date)}
                placeholder={t("placeholder_seleccione_fecha")}
                id="fecha_fin"
                name="fecha_fin"
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              <label className="block text-sm font-medium text-gray-700 mb-0">
                {t("label_vehiculo")}
              </label>
              <Select options={listaVehiculos}
                isSearchable={true}
                isClearable={true}
                value={vehiculoSelected}
                onChange={(event) => setVehiculoSelected(event)}
                placeholder={t("placeholder_seleccione_vehiculo")}
                isMulti={true}
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              {/* <label className="block text-sm font-medium text-gray-700 mb-0">
                {t("label_numero_documento")}
              </label>
              <input
                type="text"
                value={numeroDocumento}
                onChange={(e) => {
                  const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9,._\- ]/g, "");
                  setNumeroDocumento(sanitizedValue)
                }}
                placeholder={t("placeholder_ingrese_numero_documento")}
                className="w-full p-1.5 border border-gray-300 rounded-md"
                maxLength={24}
              />
              <p className="text-sm text-gray-500 flex justify-end">{String(numeroDocumento).length}/24</p>
              */}
            </div>
          </div>
          {/* <br /> */}
          {btnBuscar === true && (
            <div className="grid grid-cols-12 gap-4 mt-2 print:hidden">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12 flex justify-end">
                <button
                  type="button"
                  className={ESTILO_BOTON_MODAL_ACEPTAR}
                  onClick={() => {
                    setDetalleInforme([]);
                    obtenerDatosInforme();
                  }}
                >
                  {t("label_buscar")}
                </button>
              </div>
            </div>
          )}
          <br />
          {renderTablaDetalleInforme()}


          <ProcessingDialog visible={processingVisible} message={mensajeProcesando} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarTipoCombustible render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
